import React, { FC, useEffect, useState } from 'react';
import { ReactComponent as ExportOrdersIcon } from '../../../assets/icons/document-upload.svg';
import {
  BaseModal,
  Button,
  DateRangeSelector,
  ENUM_DATE_RANGE,
  Input,
  getDateRangeSelector
} from '@cokitchen/cokitchen-components';
import { STORAGE_KEYS } from 'utils/constants';

interface ExportOrdersModalType {
  show: boolean;
  onClose: () => void;
  title: string;
  loading?: boolean;

  onSubmit: (
    email: string,
    dateRange: {
      startDate: Date;
      endDate: Date;
    }
  ) => void;
}

interface ExportOrdersModalFooterType {
  loading: boolean;
  onConfirm: () => void;
  disabled: boolean;
}

const ExportModalFooter: FC<ExportOrdersModalFooterType> = ({ onConfirm, loading, disabled }) => (
  <Button
    small
    color='primary'
    variant='block'
    className='mx-auto'
    loading={loading}
    disabled={disabled}
    onClick={onConfirm}>
    Confirm
  </Button>
);

const ExportModal: FC<ExportOrdersModalType> = ({ show, onClose, title, onSubmit, loading }) => {
  const [emailAddress, setEmailAddress] = useState('');
  const [dateRange, setDateRange] = useState(getDateRangeSelector(ENUM_DATE_RANGE.ALL));

  useEffect(() => {
    if (show) {
      const defaultEmail = localStorage.getItem(STORAGE_KEYS.EMAIL);
      setEmailAddress(defaultEmail ?? '');
      setDateRange(getDateRangeSelector(ENUM_DATE_RANGE.ALL));
    }
  }, [show]);

  const sendDetails = () => {
    onSubmit(emailAddress, dateRange);
  };
  const validate = !emailAddress || !dateRange.startDate || !dateRange.endDate;
  return (
    <BaseModal
      isOpen={show}
      title={title}
      description='Provide your mail address to have your export sent to your mail'
      titleIcon={<ExportOrdersIcon />}
      titleIconColor='info'
      onRequestClose={onClose}
      footer={
        <ExportModalFooter loading={loading ?? false} onConfirm={sendDetails} disabled={validate} />
      }>
      <div className='space-y-3'>
        <Input
          label='Email Address'
          placeholder='paul@gmail.com'
          value={emailAddress}
          onChange={(e) => setEmailAddress(e.target.value)}
          name='emailAddress'
        />
        <div>
          <p className='font-medium text-base mb-2'>Duration</p>
          <DateRangeSelector
            showTime
            defaultRange={ENUM_DATE_RANGE.ALL}
            onChange={(v) => setDateRange(v.date)}
            className='py-5 text-base border-gray-6'
            isInput
          />
        </div>
      </div>
    </BaseModal>
  );
};

export default ExportModal;
